import { Box, Image } from '@chakra-ui/react';

import barIcon from '../../assets/svg/bar.svg';
import boxIcon from '../../assets/svg/box.svg';
import distributionIcon from '../../assets/svg/distribution.svg';
import divergingBarIcon from '../../assets/svg/diverging-bar.svg';
import divergingBarComboIcon from '../../assets/svg/diverging-bar-combo.svg';
import gaugeIcon from '../../assets/svg/gauge.svg';
import groupedBarIcon from '../../assets/svg/grouped-bar.svg';
import lineIcon from '../../assets/svg/line.svg';
import mapIcon from '../../assets/svg/map.svg';
import naIcon from '../../assets/svg/na.svg';
import sankeyIcon from '../../assets/svg/sankey.svg';
import stackedBarIcon from '../../assets/svg/stacked-bar.svg';
import tableIcon from '../../assets/svg/table.svg';
import textIcon from '../../assets/svg/text.svg';
import treemapIcon from '../../assets/svg/treemap.svg';
import volumeIcon from '../../assets/svg/volume.svg';
import type { SelectableChartType } from '../PageConfigProvider/types/chart';

const iconMap: Record<SelectableChartType, string> = {
  bar: barIcon,
  line: lineIcon,
  treemap: treemapIcon,
  'stacked-bar': stackedBarIcon,
  'grouped-bar': groupedBarIcon,
  'diverging-bar': divergingBarIcon,
  'diverging-bar-combo': divergingBarComboIcon,
  sankey: sankeyIcon,
  volume: volumeIcon,
  distribution: distributionIcon,
  box: boxIcon,
  map: mapIcon,
  gauge: gaugeIcon,
  table: tableIcon,
  text: textIcon,
  'ai-summary': textIcon,
};

export const ChartIcon = ({ type }: { type: SelectableChartType }) => {
  return (
    <Box boxSize="24px">
      <Image src={iconMap[type]} alt={`${type} icon`} boxSize="100%" />
    </Box>
  );
};

export const NonSelectableChartIcon = () => {
  return (
    <Box boxSize="24px">
      <Image src={naIcon} alt="na icon" boxSize="100%" />
    </Box>
  );
};
